module.exports = __webpack_public_path__ + "static/img/coal-generator_256.998edb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coal-generator_256.png
// module id = w9WZ
// module chunks = 0